module.exports = __webpack_public_path__ + "static/media/win-pic-lucky-draw-prize.0678b43a.png";